<template>
    <v-row dense>
        <v-col cols="12" md="6">
            <v-select
                :items="pickUpItems"
                :disabled="disabled"
                :label="$t('carsRent.pick-up_point')"
                density="compact"
                @update:model-value="setPickUpLocation"
            />
        </v-col>
        <v-col cols="12" md="6">
            <v-select
                :items="pickUpItems"
                :disabled="disabled"
                :label="$t('carsRent.drop-off_point')"
                density="compact"
                @update:model-value="setDropOffLocation"
            />
        </v-col>
    </v-row>
</template>

<script lang="ts">
    import {Component} from 'vue-facing-decorator'
    import {CarDetailsForm} from '@/components/carsRent/booking/forms/CarDetailsForm.vue'

    @Component
    export class CarRentPoints extends CarDetailsForm {
        clearLocations() {}
    }

    export default CarRentPoints
</script>
